import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Clock } from '@/components/Icons/Clock';
import { themeSelector, waitingTimeThresholdSelector } from '@/state/config';
import styles from './WaitingTime.module.scss';
const timeConverter = (waitingTime, t) => {
    const minutes = Math.floor(waitingTime / 60);
    return `${minutes} ${t('overview.mins')}`;
};
export const WaitingTime = ({ waitingTime, queuePosition }) => {
    const { t } = useTranslation();
    const waitingTimeThreshold = useRecoilValue(waitingTimeThresholdSelector);
    const theme = useRecoilValue(themeSelector);
    if (waitingTime === null) {
        return null;
    }
    if (waitingTimeThreshold && waitingTimeThreshold < waitingTime) {
        return (_jsx("div", { className: styles.container, children: _jsxs("p", { children: [t('overview.high_traffic'), ' ', _jsx("span", { children: timeConverter(waitingTimeThreshold, t) })] }) }));
    }
    if (waitingTime === 0 || waitingTime < 120) {
        return (_jsx("div", { className: styles.container, children: _jsx("p", { children: t('overview.agent_soon') }) }));
    }
    return (_jsxs("div", { className: cn(styles.container, styles[theme]), children: [_jsx(Clock, {}), _jsxs("p", { children: [t('overview.estimated_time'), _jsx("span", { title: t('overview.queue_position', { 0: queuePosition }), children: timeConverter(waitingTime, t) })] })] }));
};
